import coreHelper from "@/utils/coreHelper";
import apiService from "./apiService";

const washService = {
    async getLinkedAccounts(){
        try{
            const resp = await apiService.get(`wash/get-linked-accounts`,{},true);
            return resp.data;
        }
        catch{
            return [];
        }
    },
    async getBillsByAcctNo(acctno){
        try{
            const resp = await apiService.get(`wash/${acctno.trim()}/get-bills`,{},true);
            return resp.data;
        }
        catch{
            return [];
        }
    },
    async removeAccount(acctno){
        try{
            const resp = await apiService.delete(`wash/${acctno.trim()}/remove-link`,true);
            return resp.data;
        }
        catch{
            return coreHelper.createGenericResponseError();
        }
    },
    async lookup(acctno){
        try{
            const resp = await apiService.get(`wash/${acctno.trim()}/lookup`,{},true);
            return resp.data;
        }
        catch{
            return null;
        }
    },
    async bindAccount(acctno){
        try{
            const resp = await apiService.put(`wash/${acctno.trim()}/bind`,{},true);
            return resp.data;
        }
        catch{
            return coreHelper.createGenericResponseError();
        }
    }
}

export default washService;